import * as types from '../../actions/actionTypes';

const defaultState = {
  isLoading: true,
  messageInvitation: '',
  acceptedToJoinTeam: null,
  teamJoinedId: '',
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case types.HANDLE_INVITATION:
      return { ...state, isLoading: true };
    case types.HANDLE_INVITATION_SUCCESS:
      return {
        ...state,
        isLoading: false,
        teamJoinedId: action.data,
        acceptedToJoinTeam: true,
        messageInvitation: action.message,
      };
    case types.HANDLE_INVITATION_FAILED:
      return { ...state, isLoading: false, messageInvitation: action.message };

    case types.DECLINE_INVITATION:
      return { ...state, isLoading: true };
    case types.DECLINE_INVITATION_SUCCESS:
      return { ...state, isLoading: false, acceptedToJoinTeam: false, messageInvitation: action.message };
    case types.DECLINE_INVITATION_FAILED:
      return { ...state, isLoading: false, messageInvitation: action.message };

    default:
      return state;
  }
};
